<!--

  <fa-kt-post-fond [style.width]="'100%'" [value]="$postFond | async" (finished)="finishedPostFond($event)"></fa-kt-post-fond>
    
  <fa-kt-delete-fond [style.width]="'100%'" [value]="$deleteFond | async" (finished)="finishedDeleteFond($event)"></fa-kt-delete-fond>
    


-->
<!--- << custom    -->
<nz-list *ngIf="fonds" nzSize="large" [nzLoading]="$loading | async">
  <nz-list-item *ngFor="let fond of fonds" (click)="openFond(fond)">
    <nz-list-item-meta [nzDescription]="ListDescription">
      <ng-template #ListDescription> </ng-template>
      <nz-list-item-meta-title>
        <a>
          {{ fond.name }}
          <nz-divider nzType="vertical"></nz-divider>
          <span nz-typography nzType="secondary">
            {{ fond.aktiv ? 'aktiv' : 'inaktiv' }}
          </span>
        </a>
      </nz-list-item-meta-title>
    </nz-list-item-meta>
    <ul nz-list-item-actions>
      <nz-list-item-action>
        <a><i nz-icon nzType="edit" nzTheme="outline"></i></a>
      </nz-list-item-action>
    </ul>
  </nz-list-item>
  <nz-list-item>
    <button nz-button (click)="openFond({})" nzType="dashed" [disabled]="disabled">
      <i nz-icon nzType="plus" nzTheme="outline"></i>
      Fond hinzufügen
    </button>
  </nz-list-item>
</nz-list>

<nz-modal [nzTitle]="ModalTitle" [nzContent]="ModalContent" [nzFooter]="ModalFooter" (nzOnCancel)="openFond(null)" [nzVisible]="!!($postFond | async)">
  <ng-template #ModalTitle>
    <nz-page-header [nzTitle]="ModalHeaderTitle">
      <ng-template #ModalHeaderTitle> Fond </ng-template>
      <nz-breadcrumb nz-page-header-breadcrumb> </nz-breadcrumb>
      <nz-page-header-extra>
        <fa-kt-delete-fond [style.width]="'100%'" [value]="$deleteFond | async" (finished)="finishedDeleteFond()"></fa-kt-delete-fond>
      </nz-page-header-extra>
    </nz-page-header>
  </ng-template>
  <ng-template #ModalContent>
    <nz-row>
      <fa-kt-post-fond [style.width]="'100%'" [value]="$postFond | async" (finished)="finishedPostFond()"></fa-kt-post-fond>
    </nz-row>
  </ng-template>
  <ng-template #ModalFooter>
    <pbc-meta [value]="($postFond | async)?.fond"></pbc-meta>
  </ng-template>
</nz-modal>
<!---    custom >> -->
